import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/common.css'
import { initRequest } from './utils/request'

Vue.use(ElementUI)
Vue.config.productionTip = false

initRequest()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
